export function formatAndSortDates(inputArray: { date: string; value: number }[]) {
	const monthNames = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек']

	const formattedData = inputArray.map((item: any) => {
		const date = new Date(item.date)
		const day = date.getDate()
		const month = monthNames[date.getMonth()]
		item.formattedDate = `${day} ${month}`
		return item
	})

	const sortedData = formattedData.sort((a, b) => {
		const dateA = new Date(a.date)
		const dateB = new Date(b.date)
		//@ts-ignore
		return dateA - dateB
	})

	return sortedData.map((el) => {
		el.date = el.formattedDate
		return el
	})
}

export function formatDate(date: string | number | Date, options: Intl.DateTimeFormatOptions, lang?: string) {
	if (typeof date !== 'object') {
		date = new Date(typeof date === 'number' ? date : Date.parse(date))
	}

	const formatter = Intl.DateTimeFormat('ru', options)
	return formatter.format(date)
}

export function getDaysLeft(iso: string | null | undefined): number | null {
	if (!iso?.trim()) return null
	const target = new Date(iso)
	if (Number.isNaN(target.getTime())) return null

	const now = new Date()
	const msDiff = target.getTime() - now.getTime()
	return Math.max(0, Math.ceil(msDiff / (1000 * 60 * 60 * 24)))
}

